export enum UserStatus {
    novoUsuario = "Novo usuário",
    ativo = "Ativo",
    inativo = "Inativo",    
    bloqueado = "Bloqueado",
    bloqueadoAdm = "Bloqueado ADM"
}